import {Button} from "antd";
import {useNavigate} from "react-router-dom";
import {MANAGER_PATH} from "@/constant/url-path.ts";
import {useTranslation} from "react-i18next";

const UnAuthorizationPage = () => {
    const {t} = useTranslation();
    const navigate = useNavigate();

    return (
        <section className="bg-white dark:bg-gray-900">
            <div className="py-8 px-4 mx-auto max-w-screen-xl lg:py-16 lg:px-6">
                <div className="mx-auto max-w-screen-sm text-center">
                    <h1 className="mb-4 text-7xl tracking-tight font-extrabold lg:text-9xl text-primary-600 dark:text-primary-500">
                        401
                    </h1>
                    <p className="mb-4 text-3xl tracking-tight font-bold text-gray-900 md:text-4xl dark:text-white">
                        {t('title.somethingWrong')}
                    </p>
                    <p className="mb-4 text-lg font-light text-gray-500 dark:text-gray-400">
                        {t('message.message401Page')}
                    </p>
                    <Button
                        className={'m-1'}
                        type={'primary'}
                        size={'large'}
                        onClick={() => navigate(MANAGER_PATH.AUTH.SIGN_IN)}
                    >
                        {t('button.gotoLogin')}
                    </Button>
                </div>
            </div>
        </section>
    )
}

export default UnAuthorizationPage;